import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Base64ImageData } from './base64-image-data';
import { FileReaderService } from './file-reader.service';

@Injectable({
    providedIn: 'root'
})
export class ImageReaderService {
    constructor(private _fileReaderService: FileReaderService) {}

    public readImageDataFromFileAsync(file: File): Observable<Base64ImageData> {
        return this._fileReaderService.readFileAsDataUrlAsync(file).pipe(
            map((data) => new Base64ImageData(data)),
            catchError((err: Error) =>
                throwError(
                    new Error('Failed to read image from file: ' + err.message)
                )
            )
        );
    }
}
